import React from 'react';
import styled from 'styled-components';
import MobileReportLink from '@catalogo/template-americanas-mobile-product/src/components/report-link';

const ReportUI = styled.div`
  padding: 35px 20px 0px 0px;
`;

const ReportLink = ({ id }) => (
  <ReportUI>
    <MobileReportLink id={id} />
  </ReportUI>
);

export default ReportLink;
